import api from "./api";
import moment from "moment";

type billDetails = {
  warehouseId: number;
  supplierId: number;
  paymentModeId: number;
  date: string;
  dueDate: string;
  currencyId: number;
  exchangeRate: number;
  taxExchangeRate: number;
  discount: number;
  notes: string;
  sessionId?: string | undefined;
};
type ItemDetails = {
  barcode: string;
  quantity: number;
  price: number;
  tax: number;
  discount: number;
  notes: string;
};
const sessionId = localStorage.getItem("sessionId");

const returnCompleteDto = (Dto: ItemDetails | billDetails) => {
  return { ...Dto, sessionId: sessionId };
};

export const getBills = async (Dto: {
  q?: string,
  limit?: number,
  offset?: number,
  from?: string,
  to?: string
}) => {
  const queryParams: Record<string, string> = {};

  if (Dto.q) {
    queryParams.q = Dto.q;
  }

  if (Dto.limit) {
    queryParams.limit = Dto.limit.toString();
  }

  if (Dto.offset) {
    queryParams.offset = Dto.offset.toString();
  }

  if (Dto.from) {
    queryParams.from = Dto.from.toString();
  }

  if (Dto.to) {
    queryParams.to = Dto.to.toString();
  }

  const queryString = Object.keys(queryParams)
    .map(key => `${key}=${queryParams[key]}`)
    .join('&');

  // Construct the API request URL with the query string
  const url = `/bills${queryString ? `?${queryString}` : ''}`;

  return await api.get(url);
}

export const getBillsResources = async () => {
  return await api.get(`/bills/resources`);
}

// export const getBill = async (billId: number) => {
//   return await api.get(`/bills/${billId}`);
// };

export const getBill = async (Dto: {
  billId: number;
  q?: string;
  limit?: number;
  offset?: number;
}) => {
  // Construct the query string
  const queryParams: Record<string, string> = {};

  if (Dto.q) {
    queryParams.q = Dto.q;
  }

  if (Dto.limit) {
    queryParams.limit = Dto.limit.toString();
  }

  if (Dto.offset) {
    queryParams.offset = Dto.offset.toString();
  }

  const queryString = Object.keys(queryParams)
    .map(key => `${key}=${queryParams[key]}`)
    .join('&');

  // Construct the API request URL with the query string
  const url = `/bills/${Dto.billId}${queryString ? `?${queryString}` : ''}`;

  return await api.get(url);
};

export const createBill = async (billDetails: billDetails) => {
  return await api.post(`/bills`, billDetails);
};
export const createBillItem = async (billId: any, itemDetails: ItemDetails) => {
  return await api.post(
    `/bills/${billId}/items`,
    returnCompleteDto(itemDetails)
  );
};

export const createBillItemScan = async (billId: string | undefined, itemDetails: ItemDetails) => {
  return await api.post(
    `/bills/${billId}/items/scan`, itemDetails
  )
};

export const deleteBill = async (billId: any) => {
  return await api.delete(`/bills/${billId}`);
};
export const deleteBillItem = async (billId: any, itemId: any) => {
  return await api.delete(`/bills/${billId}/items/${itemId}`);
};

export const getBillById = async (billId: number | undefined) => {
  return await api.get(`/bills/${billId}`);
};
export const deleteBillReturns = async (billId: number | undefined) => {
  return await api.delete(`/bills-returns/${billId}`);
};
export const getBillItemById = async (billId: any, itemId: any) => {
  return await api.get(`/bills/${billId}/items/${itemId}`);
};

export const editBill = async (billId: any, billDetails: any) => {
  return await api.put(`/bills/${billId}`, billDetails);
};
export const editBillItem = async (
  billId: any,
  itemId: any,
  itemDetails: any
) => {
  return await api.put(
    `/bills/${billId}/items/${itemId}`,
    returnCompleteDto(itemDetails)
  );
};
export const getBillsDropdown = async (supplierId: number) => {
  return await api.get(`/bills/dropdown/${supplierId}`);
};

export const payBill = async (id: number | undefined) => {
  const currDateFormatted = moment().format("MM/DD/YYYY HH:mm:ss");
  return await api.post(`/bills/${id}/pay`, {
    paidDate: currDateFormatted,
  });
};
export const approveBill = async (id: number | undefined) => {
  const currDateFormatted = moment().format("MM/DD/YYYY HH:mm:ss");
  return await api.post(`/bills/${id}/approve`, {
    approvedDate: currDateFormatted,
  });
};
